import { NotionEmptyIcon } from "../assets/NotionEmptyIcon";

export type NotionIconElementType =
  | { type: "emoji"; emoji: string }
  | { type: "external"; external: { url: string } }
  | { type: "file"; file: { url: string; expiry_time: string } };

export const getPageTitle = (page: any) => {
  let title = "";
  if (page?.title && Array.isArray(page?.title) && page?.title?.length) {
    title = page.title[0].plain_text;
  } else if (page?.properties) {
    const titleProp = Object.values(page.properties).find(
      (prop: any) => prop?.type === "title",
    );
    titleProp && (title = (titleProp as any).title?.[0]?.plain_text);
  }
  return title || "Untitled";
};

/**
 * Render a Notion icon payload. The payload comes straight off the Notion API
 * (and off persisted scenes written by older versions), so it is untrusted: any
 * shape mismatch degrades to the empty icon rather than throwing inside the
 * canvas render tree. Never mutates the input — icons live on scene elements,
 * which are treated as immutable.
 */
export const processNotionIcon = (icon: NotionIconElementType | null) => {
  const shape = icon as any;
  if (!shape || typeof shape !== "object" || typeof shape.type !== "string") {
    return <NotionEmptyIcon />;
  }
  if (shape.type === "emoji") {
    if (typeof shape.emoji !== "string") {
      return <NotionEmptyIcon />;
    }
    return (
      <div
        role="img"
        data-emoji={shape.emoji}
        tabIndex={0}
        style={{ cursor: "pointer" }}
      >
        {shape.emoji}
      </div>
    );
  }
  if (shape.type === "external") {
    const raw = shape.external?.url;
    if (typeof raw !== "string") {
      return <NotionEmptyIcon />;
    }
    // Notion returns site-relative URLs for its built-in icons.
    const url = raw.startsWith("/") ? `https://notion.so${raw}` : raw;
    return <img src={url} alt="notion-icon" />;
  }
  if (shape.type === "file") {
    const url = shape.file?.url;
    if (typeof url !== "string") {
      return <NotionEmptyIcon />;
    }
    return <img src={url} alt="notion-icon" />;
  }
  return <NotionEmptyIcon />;
};
